import { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, Circle, Polyline, useMap } from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const COLORS = {
  victim: "#DC2626",
  responder: "#F97316",
  community: "#111827",
  home: "#16A34A",
  volunteer: "#7c3aed",
  you: "#2563eb",
};

const markerIcon = (type = "responder", { pulse = false, letter = "" } = {}) => {
  const color = COLORS[type] || COLORS.responder;
  const ring = pulse
    ? `<span style="position:absolute;inset:-8px;border-radius:9999px;background:${color}33;animation:llpulse 1.6s ease-out infinite;"></span>`
    : "";
  const inner = letter
    ? `<span style="color:#fff;font-weight:800;font-size:12px;line-height:1;">${letter}</span>`
    : `<span style="width:8px;height:8px;border-radius:9999px;background:#fff;display:block;"></span>`;
  return L.divIcon({
    className: "ll-marker",
    html: `<div style="position:relative;width:28px;height:28px;">${ring}
      <div style="position:relative;width:28px;height:28px;border-radius:9999px;background:${color};
        border:2.5px solid #fff;box-shadow:0 3px 10px rgba(0,0,0,.35);display:flex;align-items:center;justify-content:center;">
        ${inner}</div></div>`,
    iconSize: [28, 28],
    iconAnchor: [14, 14],
    popupAnchor: [0, -16],
  });
};

const Recenter = ({ center, zoom }) => {
  const map = useMap();
  useEffect(() => {
    if (center) map.setView(center, zoom ?? map.getZoom(), { animate: true });
  }, [center, zoom, map]);
  return null;
};

export const LiveMap = ({
  center,
  zoom = 15,
  height = 220,
  markers = [],
  routes = [],
  accuracyM = null,
  testId = "live-map",
}) => {
  if (!center) return null;
  return (
    <div
      className="relative rounded-3xl overflow-hidden border border-[#111827]/10 shadow-[0_8px_30px_rgb(0,0,0,0.06)]"
      style={{ height }}
      data-testid={testId}
    >
      <MapContainer center={center} zoom={zoom} style={{ height: "100%", width: "100%" }} scrollWheelZoom={false} zoomControl={false} attributionControl={false}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
        <Recenter center={center} zoom={zoom} />
        {accuracyM != null && (
          <Circle center={center} radius={Math.min(accuracyM, 400)} pathOptions={{ color: "#DC2626", fillColor: "#DC2626", fillOpacity: 0.08, weight: 1 }} />
        )}
        {routes.map((r, i) => (
          <Polyline key={i} positions={r} pathOptions={{ color: "#F97316", weight: 3, dashArray: "6 8", opacity: 0.8 }} />
        ))}
        {markers.map((m, i) => (
          <Marker key={m.id || i} position={[m.lat, m.lng]} icon={markerIcon(m.type, { pulse: m.pulse, letter: m.letter })}>
            {(m.label || m.sub) && (
              <Popup>
                <div style={{ fontWeight: 700 }}>{m.label}</div>
                {m.sub && <div style={{ fontSize: 12, opacity: 0.7 }}>{m.sub}</div>}
              </Popup>
            )}
          </Marker>
        ))}
      </MapContainer>
    </div>
  );
};
